// PLAYER
(function () {
  "use strict";

  // Variáveis
  const $players = $(".rl-player");
  const logoDefault = $(".rl-player-cover-img").attr("src");
  let $playerLyric;
  //const logoDefault = $(".logo-player").attr("src");
  const $modal = $("#modal-letra");
  const $modalInfos = $("#letra-infos");
  const $modalLetra = $("#letra-texto");

  $players.each(function () {
    // Variáveis
    const $player = $(this);
    const streamUrl = $player.data("stream");
    const streamApi = $player.data("api");
    const $playerControl = $player.find(
      ".rl-player-media-control:not(.disabled)"
    );
    const $volume = $player.find(".rl-player-volume");
    const $volumeIcon = $volume.find(".rl-player-volume-icon > i");
    const $volumeControl = $volume.find(".rl-player-volume-control > input");
    let streamAudio;
    let playing = false;
    let volume = $volumeControl.val();

    // Carrega o áudio
    loadPlayer();
    function loadPlayer() {
      const cacheControl = new Date().getTime();
      streamAudio = new Audio(streamUrl + "?v=" + cacheControl);
    }

    // Obtém as informações
    getStreamInfos($player, streamApi);
    setInterval(() => {
      getStreamInfos($player, streamApi);
    }, 15000);

    // Evento de click no play
    $playerControl.on("click", function (ev) {
      ev.preventDefault();
      togglePlayer();
    });

    // Evento do volume
    $volumeControl.on("change", changeVolume);

    // Altera o volume
    function changeVolume() {
      volume = $volumeControl.val();
      if (volume >= 0.6) {
        $volumeIcon
          .removeClass("fa-volume-off fa-volume-down")
          .addClass("fa-volume-up");
      } else if (volume > 0 && volume < 0.6) {
        $volumeIcon
          .removeClass("fa-volume-off fa-volume-up")
          .addClass("fa-volume-down");
      } else {
        $volumeIcon
          .removeClass("fa-volume-up fa-volume-down")
          .addClass("fa-volume-off");
      }
      if (streamAudio) {
        streamAudio.volume = volume;
      }
    }

    // Reproduz ou pause o player
    function togglePlayer() {
      if (playing) {
        pauseRadio();
      } else {
        playRadio();
      }
    }

    // Reproduz o player
    function playRadio() {
      playing = true;
      $player.addClass("playing");
      $playerControl.attr("title", "Parar");
      streamAudio.play();
    }

    // Pausa o player
    function pauseRadio() {
      playing = false;
      $player.removeClass("playing");
      $playerControl.attr("title", "Reproduzir");
      streamAudio.pause();
      streamAudio.currentTime = 0;
      streamAudio = null;
      loadPlayer();
    }
  });

  // Obtém as informações da stream
  function getStreamInfos($player, urlApi) {
    if ($player.length > 0) {
      const $playerMusic = $player.find(".rl-player-media-title");
      const $playerAuthor = $player.find(".rl-player-media-author");
      const $playerCover = $player.find(".rl-player-cover-img");
      $playerLyric = $player.find(".rl-player-media-lyric");
      let playerMusic = "Rádio Leve";
      let playerAuthor = "Rádio Leve";
      $.ajaxSetup({ cache: false });
      $.getJSON(urlApi, function (resp) {
        // console.log(resp);
        if (resp.playing) {
          if (resp.playing.title.includes("MÚSICA")) {
            playerMusic = resp.playing.title;
            playerAuthor = resp.playing.name;
          } else {
            const titleArr = resp.playing.title.split(" - ");
            playerAuthor = titleArr[0];
            playerMusic = titleArr[1];
          }
        }
        /* if (resp.song_data) {
          playerCover = resp.song_data.cover;
        } */
        setPlayerData();
      }).fail(function (resp) {
        console.log(resp);
        setPlayerData();
      });
      function setPlayerData() {
        $playerMusic.text(playerMusic);
        $playerAuthor.text(playerAuthor);
        getAlbumCover($playerCover, playerAuthor);
        getMusicLyric(playerAuthor, playerMusic);
      }
    }
  }

  // Obtém a imagem do álbum
  function getAlbumCover($playerCover, artist) {
    if (artist != "Rádio Leve") {
      albumArt(artist, { size: "small" }, (error, response) => {
        if (typeof response === "string" && response.includes("https")) {
          $playerCover.css("background-image", "url(" + response + ")");
        } else {
          $playerCover.css("background-image", "url(" + logoDefault + ")");
        }
      });
    } else {
      $playerCover.css("background-image", "url(" + logoDefault + ")");
    }
  }

  // Obtém a letra da música
  function getMusicLyric(artist, song) {
    getMusicLyricVagalume(artist, song);
  }

  // Obtém a letra da música do Vagaluime (vagalume.com.br)
  function getMusicLyricVagalume(artist, song) {
    const apiKey = "570d19d7323b16daf6fb306c0346a4d8";
    const urlApi = "https://api.vagalume.com.br/search.php";
    if (artist != "Rádio Leve") {
      $.getJSON(
        urlApi + "?art=" + artist + "&mus=" + song,
        +"&apikey=" + apiKey,
        function (data) {
          if (data.type == "exact" || data.type == "aprox") {
            const letra = data.mus[0].text;
            showLyric(song, artist, letra);
          } else {
            console.log("Vagalume: Letra da música não encontrada.");
            clearLyric();
            getMusicLyricLrclib(artist, song);
          }
        }
      );
    } else {
      clearLyric();
    }
  }

  // Obtém a letra da música do LrcLib (lrclib.net)
  function getMusicLyricLrclib(artist, song) {
    const urlApi = "https://lrclib.net/api/get";
    if (artist != "Rádio Leve") {
      $.getJSON(
        urlApi + "?artist_name=" + artist + "&track_name=" + song,
        function (data) {
          if (data.plainLyrics) {
            const letra = data.plainLyrics;
            showLyric(song, artist, letra);
          } else {
            clearLyric();
            console.log("LrcLib: Letra da música não encontrada.");
          }
        }
      ).fail(function (jqXHR) {
        console.log("LrcLib: Letra da música não encontrada.");
        clearLyric();
      });
    } else {
      clearLyric();
    }
  }

  // Exibe a letra da música
  function showLyric(song, artist, lyric) {
    $modalInfos.text(song + " - " + artist);
    $modalLetra.text(lyric);
    $playerLyric.show();
  }

  // Limpa a letra da música
  function clearLyric() {
    $modalInfos.text("");
    $modalLetra.text("");
    $playerLyric.hide();
  }
})();
